import React, { FC, ReactNode } from 'react'

import { IconInfo } from '@avantstay/backoffice-vectors'

import { Tooltip } from '../Tooltip'
import * as S from './IndicatorValueWithComparison.styles'

interface IndicatorValueWithComparisonProps {
  value?: number | null
  relativeLabel?: string
  relativeValue?: number
  valueColor?(value: number): string
  formatValue?(value: number): string
  formatRelativeValue?(value: number): string
  isValueBold?: boolean
  disableTooltip?: boolean
  tooltipContent?: ReactNode
  shouldHideTooltip?: boolean
}

// Keep this export clean, free of wrapping HOCs
export const IndicatorValueWithComparison: FC<IndicatorValueWithComparisonProps> = ({
  value,
  valueColor,
  relativeLabel,
  relativeValue,
  formatValue,
  formatRelativeValue,
  isValueBold,
  disableTooltip,
  tooltipContent,
  shouldHideTooltip,
}) => {
  const colorScheme = value != null && valueColor ? valueColor(value) : undefined

  const renderRelativeValue = () => {
    if (relativeValue && relativeValue !== 0) {
      const variation = relativeValue

      return (
        <S.VariationContainer>
          <S.VariationValue $scale={variation}>
            <p data-cy="relative-value-input">
              {formatRelativeValue && relativeValue ? formatRelativeValue(relativeValue) : '-'}
            </p>
            <S.VariationArrow $scale={variation} />
          </S.VariationValue>
          {!shouldHideTooltip ? (
            <Tooltip disabled={disableTooltip} content={tooltipContent}>
              <IconInfo />
            </Tooltip>
          ) : null}
        </S.VariationContainer>
      )
    }

    return tooltipContent && !shouldHideTooltip ? (
      <Tooltip disabled={disableTooltip} content={tooltipContent}>
        <IconInfo />
      </Tooltip>
    ) : null
  }

  const formattedValue = formatValue && value != null ? formatValue(value) : value

  return (
    <S.IndicatorContainer>
      <S.CurrentValue bold={isValueBold} color={colorScheme}>
        {formattedValue != undefined ? formattedValue : <S.NA>-</S.NA>}
      </S.CurrentValue>
      <div>
        {renderRelativeValue()}
        {relativeLabel && <S.VariationPeriod>{relativeLabel}</S.VariationPeriod>}
      </div>
    </S.IndicatorContainer>
  )
}
